import { useState } from "react";
import React, { useEffect } from "react";
import MainMenu from "./MainMenu";
import NoticesDisplay from "./NoticesDisplay";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function NoticeForm() {

  const [open, setOpen] = useState(true);

  // Auto collapse on mobile + auto expand on desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOpen(false); // hide on mobile
      } else {
        setOpen(true); // show on desktop
      }
    };

    handleResize(); // run on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [title, setTitle] = useState("");
  const [editorData, setEditorData] = useState("");

  const handleSubmit = async () => {
    const res = await fetch("https://spst.in/myapp/api/insert_notice.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title, content: editorData }),
    });

    const response = await res.json();
    window.location.reload();
  };

  return (
    <div className="container-fluid p-0">
      <div
        className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
        style={{
          zIndex: 999,
          cursor: "pointer",
          position: "fixed",
          left: open ? "350px" : "60px",
          top: "0",
          transition: "left 0.3s ease"
        }}
        onClick={() => setOpen(!open)}
      >
        <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
          ☰
        </span>
      </div>

      <div className="d-flex" style={{ height: "100vh" }}>

        {/* LEFT SIDEBAR */}
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease",

          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddiingLeft: '30px'
          }}
        >
          <div>
            <TopBanner />
          </div>
          <div className="">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ fontWeight: "700" }}>Enter Updates</h4>

                <CKEditor
                  editor={ClassicEditor}
                  data={editorData}
                  onChange={(e, editor) => setEditorData(editor.getData())}
                />

                <textarea
                  className="form-control"
                  style={{ height: "150px" }}
                  placeholder="Enter Updates"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required></textarea>

                <button
                  className="btn btn-warning"
                  style={{ marginTop: "15px" }}
                  onClick={handleSubmit}
                >
                  Save
                </button>

              </div>
              <div className="col-md-8">
 <NoticesDisplay />
          </div>

            </div>
          </div>
        </div>

      </div>

    </div>
  );
}

export default NoticeForm;
